import { render } from "./MySchedule.vue?vue&type=template&id=8225913a&scoped=true"
import script from "./MySchedule.vue?vue&type=script&lang=js"
export * from "./MySchedule.vue?vue&type=script&lang=js"

import "./MySchedule.vue?vue&type=style&index=0&id=8225913a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8225913a"]])

export default __exports__